export const BillinCompany = {
    DOMISERVE: "DOMISERVE",
    DOMISERVE_PLUS: "DOMISERVE_PLUS",
}
